// removed by extract-text-webpack-plugin
module.exports = {"Element":"_2G817Lbyi7hxfY1j1sGHqj","Row":"_3NAKfBqfYZLtW_uVHAPHgo","ElementUp":"_32Cq22jny2YPYePdpjKcvu","Name":"_1Zp_7yZnyREhbbj_VWUfMU","FirstCol":"_3x3aW545MvtN7fEoNZqe6T","Left":"_6m648EU6hvQx9vfdMf-CG","Manage":"_6VH6E-bT1nCk7w1unXx8H","Numbers":"_25iiXCiohTpHpz2UR_6kU6","Set":"_3QDPShnR0E1Qz3-aVtiAW7","Unit":"_2t49He5A3sa9-yKDWiZy5x","BigSet":"_1MN5oPfBO6UTKJnSE3khan","TherapySet":"_3eGI9LEbt3nEDB1BKyhYaC","RemoveParameter":"_2CEXUSz5w0DK_dwkBcvYUb","Group":"_3-uX_DBuC8ph5efLckalN6","GroupEnd":"X5pDgy17-_fOMWlebPh2G","ChartTitle":"_3q40UfZ6XtNtkUPFrZ6KNp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Detail/TherapyElement/TherapyElement.css
// module id = 396
// module chunks = 0